import { StateCreator } from "zustand";
import type { AuthorizedUser } from "@/serverActions/actAuth";

import { GlobalState } from "../globalStore";

export interface AuthSlice {
  // State
  user: AuthorizedUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  isInitialized: boolean; // tack if state is initialized ()

  // Actions
  setUser: (user: AuthorizedUser | null) => void;
  setTokens: (accessToken: string | null, refreshToken: string | null) => void;
  logout: () => void;
}

export const createAuthSlice: StateCreator<GlobalState, [], [], AuthSlice> = (
  set,
  get
) => ({
  user: null,
  accessToken: null,
  refreshToken: null,
  isInitialized: false,

  setUser: (user) => set({ user }),
  setTokens: (accessToken, refreshToken) => {
    set({ accessToken, refreshToken });
    // Get current user from state to check if it exists
    const state = get();
    // Only mark as initialized if all required auth data is present
    if (accessToken && refreshToken && state.user) {
      set({ isInitialized: true });
    }
  },
  logout: () => {
    set({ user: null, accessToken: null, refreshToken: null });
    // Reset isInitialized to false on logout
    set({ isInitialized: false });
  },
});
